<template>
  <footer>
    <section class="index" ref="section">
      <h2 ref="logo" :class="{ active: active, 'bottom-logo': bottomLogo }">
        Index
      </h2>
      <ul>
        <li
          v-for="(section, index) in sections"
          :key="index"
          :style="{ color: section.color }"
        >
          <a :href="`#${section.uid}`">
            {{ section.title }}
          </a>
        </li>
      </ul>
    </section>
  </footer>
</template>

<script>
// const VueScrollTo = require("vue-scrollto");

export default {
  name: "Index",
  props: ["data", "sections", "scrollVal"],
  data() {
    return {
      active: false,
      bottomLogo: false,
    };
  },
  // methods: {
  //   goToSection: function(section) {
  //     const element = document.getElementById(section);
  //     // VueScrollTo.scrollTo(element, 1000);
  //   },
  // },
};
</script>

<style lang="scss">
.index {
  font-size: 11vw;
  letter-spacing: -0.015em;
  text-align: center;
  padding: 0;
  ul {
    margin: 0;
    padding: 1em 0 1.25em 0;
    line-height: 1.15;
    li:first-of-type,
    li.imprint {
      margin-top: 3vw;
    }
    li {
      list-style-type: none;
      margin: 0;
      padding: 0;
      a {
        border: none;
        cursor: pointer;
        text-decoration: none;
        transition: color 200ms ease;
        &:hover {
          // color: #be2239;
        }
      }
    }
  }
  h2 {
    font-size: 1em;
    font-weight: 400;
    width: 100%;
    box-sizing: border-box;
    pointer-events: none;
  }
  h2.bottom-logo {
    position: absolute;
    bottom: 0;
    top: auto;
  }
}
li.link {
  cursor: pointer;
}
</style>
